import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/key";
import PointPublicSchema from "@common/schema/key/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { keyId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${keyId}`;
  const basepath = `${parentBasepath}/:keyId`;

  return (
    <Section.Provider
      schema={[...PointPublicSchema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      <Children base={base} basepath={basepath} params={params} />
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"keys.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { keyId } }) => (
        <>
          <Crumb to={`${base}`} label={keyId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <ViewRoute.Sidebar />
  </>
);
